import Modal from 'libs/components/modal';

export default function(data, element, skipBinding) {
  var self = this;
  self.$el = $(element);
  self.saving = ko.observable(false);

  self.defaultNoticeOptions = {
    method: 'append'
  };

  self.allSelected = false;

  self.bindData = function(data){
    self.site_alert = ko.mapping.fromJS(data.site_alert);
    self.site_alert.start_date_string(self.site_alert.start_date());
    self.site_alert.end_date_string(self.site_alert.end_date());

    self.scheduling = ko.computed(function() {
      return !_.isEmpty(self.site_alert.start_date_string());
    });

    self.submitButtonText = ko.computed(function() {
      if(self.scheduling()) {
        return Kadenze.I18n.t('site_alert.schedule');
      } else {
        return Kadenze.I18n.t('site_alert.publish');
      }
    });

    self.publishingDateText = ko.computed(function() {
      if(self.scheduling()) {
        return Kadenze.Util.getMomentDateFromObservable(self.site_alert.start_date_string).format(Kadenze.I18n.t('date.formats.js_default_time'));
      } else {
        return 'Publish Immediately';
      }
    });

    var roles = ['select_all', 'student', 'instructor', 'course_creator', 'admin', 'student_not_enrolled_in_any_courses'];
    if(Kadenze.isKadenze){
      roles.push('premium_member');
    }

    self.availableRoles = ko.observableArray(roles);

    self.selectedRoles = ko.observableArray(self.site_alert.target_roles());

    if(self.selectedRoles().length < 1) {
      self.selectedRoles(['student']);
    }

    self.selectAll = ko.computed(function() {
      var index = _.indexOf(self.selectedRoles(), 'select_all');
      if(index != -1) {
        if(!self.allSelected) {
          self.selectedRoles(self.availableRoles());
          self.allSelected = true;
        }
      } else {
        if(self.allSelected) {
          self.selectedRoles([]);
          self.allSelected = false;
        }
      }
    });

    self.sendingToText = ko.computed(function() {
      if(self.selectedRoles().length < 1) {
        return 'None' ;
      } else {
        var output = [] ;
        _.each(self.selectedRoles(), function(role) {
          if(role != 'select_all') {
            output.push(s.humanize(role));
          }
        });
        return output.join(', ');
      }
    });
  };

  // remove redactor tags and add styling for site alert links
  self.processContent = function(value) {
    var $ele = $(value);
    // value has already been processed
    if($ele.html() == undefined) {
      return value;
    }
    $ele.find('a').addClass('confirmation-notification__link');
    return $ele.html();
  };

  self.clearScheduledFor = function() {
    if (document.getElementById('start_date_datepicker')) {
      document.getElementById('start_date_datepicker').value = '';
    }
    self.site_alert.start_date_string('');
    self.site_alert.start_date(null);
  };

  self.setTargetRoles = function() {
    var index = _.indexOf(self.selectedRoles(), 'select_all');
    if(index != -1) {
      self.selectedRoles().splice(index, 1);
      self.site_alert.target_roles(self.selectedRoles());
    } else {
      self.site_alert.target_roles(self.selectedRoles());
    }
  };

  self.initUI = function() {
    //setup preview functionality
    $('.site-alert__preview-holder').hide();
    $('.site-alert__preview-holder .confirmation-notification__link-dismiss').on('click', function() {
      $('.site-alert__preview-holder').slideUp(200);
    });
  };

  self.saveWithResendModal = function() {
    if(self.site_alert.id() && self.site_alert.isPublished()) {
      const $modal = Modal.for('confirmation', {
        title: 'Resend to all?',
        body: 'Some users may have already seen and dismissed this alert. Do you want to show them again?',
        cancelBtnText: 'No',
        okBtnText: 'Yes'
      });

      $modal.find('.js_cancel').on('click', function() {
        self.resend_to_all = false;
        self.save();
      });

      $modal.find('.js_ok').on('click', function() {
        self.resend_to_all = true;
        self.save();
      });
    } else {
      self.save();
    }
  };

  self.save = function(redirectToIndex) {
    if(self.saving()) {
      return;
    }

    self.saving(true);

    var type = 'POST';
    var url = Kadenze.Routes.admin_site_alerts_path();

    if(self.site_alert.id()) {
      url = Kadenze.Routes.admin_site_alert_path(self.site_alert.id());
      type = 'PATCH';
    }

    self.setTargetRoles();

    var data = ko.mapping.toJS(self.site_alert);
    data.content = self.processContent(data.content);
    data.resend_to_all = self.resend_to_all;

    if (data.start_date_string && data.start_date_string.trim().length > 0) {
      data.start_date_string = Kadenze.Util.getMomentDateFromObservable(self.site_alert.start_date_string).utc().format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    } else {
      data.start_date_string = null;
    }

    if (data.end_date_string && data.end_date_string.trim().length > 0) {
      data.end_date_string = Kadenze.Util.getMomentDateFromObservable(self.site_alert.end_date_string).utc().format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    }

    var request = new Kadenze.AjaxRequest({
      type: type,
      url: url,
      data: { 'site_alert': data },
      dataAsJson: false
    });

    return self.requestResponse(request, redirectToIndex);
  };

  self.requestResponse = function(request, redirectToIndex) {
    request.done(function(data, textStatus, xhr) {
      var data = JSON.parse(data.site_alert);
      ko.mapping.fromJS(data.site_alert, self.site_alert);
      self.bindData(data);

      var url = Kadenze.Routes.edit_admin_site_alert_path(self.site_alert.id());

      if(redirectToIndex === true) {
        Kadenze.Request.pjax({
          url: Kadenze.Routes.admin_site_alerts_path(),
          container: '#editor-container'
        });
      } else {
        Kadenze.Notice.success($.extend({}, self.defaultNoticeOptions, { message: xhr.responseJSON.message }));
      }
      self.saving(false);
    });

    request.fail(function(xhr, textStatus, errorThrown) {
      new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      self.saving(false);
    });

    return request;
  };

  self.publish = function() {
    self.site_alert.start_date_string(null);
    self.setTargetRoles();
    var request = null;
    var url = '';
    var data = ko.mapping.toJS(self.site_alert);
    data.status = 'published';
    data.content = self.processContent(data.content);

    if (data.start_date_string && data.start_date_string.trim().length > 0) {
      data.start_date_string = Kadenze.Util.getMomentDateFromObservable(self.site_alert.start_date_string).utc().format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    }

    if (data.end_date_string && data.end_date_string.trim().length > 0) {
      data.end_date_string = Kadenze.Util.getMomentDateFromObservable(self.site_alert.end_date_string).utc().format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    }

    var publish = function() {
      url  = Kadenze.Routes.admin_publish_site_alert_path(self.site_alert.id());
      return new Kadenze.AjaxRequest({
        type: 'PATCH',
        url: url,
        data: { 'site_alert': data },
        dataAsJson: false
      });
    };

    if(self.site_alert.id() === null) {
      var response = self.save(false);
      response.success(function() {
        request = publish();
        self.requestResponse(request, true);
      });
    } else {
      request = publish();
      self.requestResponse(request, true);
    }
  };


  self.preview = function() {
    var previewContainer = $('.site-alert__preview-holder');
    if(self.site_alert.content() !== null && self.site_alert.content() !== '') {
      self.site_alert.content(self.processContent(self.site_alert.content()));
      $('.site-alert__preview-holder .confirmation-notification__copy').html(self.site_alert.content());
    } else {
      $('.site-alert__preview-holder .confirmation-notification__copy').html('Content');
    }
    previewContainer.slideDown(200);
  };

  self.deleteSiteAlert = function() {
    var redirectUrl = Kadenze.Routes.admin_site_alerts_path();
    var method = 'DELETE';
    if(!self.site_alert.id()) {
      Kadenze.Request.pjax({url: redirectUrl, container: '#main-pjax-container'});
      return;
    }

    var url = Kadenze.Routes.admin_site_alert_path(self.site_alert.id());
    var request = Kadenze.UIUtil.makeRequest(url, method, null, '#main-pjax-container',
      function(xhr, settings) { //BeforeSave
        self.saving(true);
      },
      function(data, textStatus, xhr) { //Success
        new Kadenze.Notice.success($.extend({dismissible: true}, self.defaultNoticeOptions));
        Kadenze.Request.pjax({url: redirectUrl, container: '#main-pjax-container'});
      },
      function(xhr, textStatus, errorThrown) { //Error
        new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      },
      function(xhr, textStatus) { //Complete
        self.saving(false);
        //Nothing
      });
  };

  const __construct = function(that) {
    console.log('constructor called for AdminSiteAlertViewModel');
    if(!skipBinding) {
      data = JSON.parse(data);
      self.bindData(data);
    }
  }(this);

  return self;
}

